import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const analysisApi = {
  uploadJds: (files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append('files', file));
    return axios.post(`${API}/analysis/upload-jds`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    });
  },

  lookupTitles: (titles, functionName) =>
    axios.post(`${API}/analysis/lookup-titles`, {
      titles,
      function: functionName || null,
      sector: localStorage.getItem('demo_sector') || '',
      org_name: localStorage.getItem('demo_org_name') || '',
      region: (() => {
        const currency = localStorage.getItem('demo_currency') || '';
        if (currency === 'AED') return 'UAE';
        if (currency === 'MUR') return 'Mauritius';
        if (currency === 'INR') return 'India';
        if (currency === 'GBP') return 'UK';
        return 'India';
      })(),
    }),

  confirmRoles: (functionName, roles) =>
    axios.post(`${API}/analysis/confirm-roles`, {
      function: functionName,
      roles,
    }),

  molecularise: (sessionId, valueDiscipline) =>
    axios.post(`${API}/analysis/molecularise`, {
      session_id: sessionId,
      value_discipline: valueDiscipline,
    }),

  generateBlueprint: (sessionId, selectedVectors) =>
    axios.post(`${API}/analysis/generate-blueprint`, {
      session_id: sessionId,
      selected_vectors: selectedVectors,
    }),

  getLatestSession: () =>
    axios.get(`${API}/analysis/session/latest`),

  getSession: (sessionId) =>
    axios.get(`${API}/analysis/session/${sessionId}`),

  deleteSession: (sessionId) =>
    axios.delete(`${API}/analysis/session/${sessionId}`),

  activateStage: (sessionId, rolesToActivate) =>
    axios.post(`${API}/analysis/activate-stage`, {
      session_id: sessionId,
      roles_to_activate: rolesToActivate,
    }),
};

export default analysisApi;
